const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID: 16,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
